import React from 'react'
import Sidebar from '../Layout/Sidebar';
import { Layout } from "antd";
import CustomHeader from '../Layout/Header';

import { useState, useEffect } from 'react'
import './css/wallet-dashboard.css';
import DeselectTupupicon from './img/deselect-topup-icon.svg';
import SelectTupupicon from './img/select-topup-icon.svg';
import MonthlyTopupIcon from './img/monthly-payment-icon.svg';
import AccessBasedIcon from './img/access-based-icon.svg';
import wallelBalicon from './img/balance-icon-60x60.svg';
import HelpImg from './img/help-img.png';
import axios from 'axios';
import { toast } from "react-toastify";
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import { allLocationWithShortName, dataUser } from '../Helpers/util';
import { getLocationNameById } from '../../utils/getLocationNameById';
import SuccessIcon from './img/Success-Icon.png';
import insufficientBalIcon from './img/insufficientBal-icon.png';
import SwInput from '../Common/FormComponent/SwInput';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect'
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
import SwButton from '../Common/SwButtons/SwButtons';
import SwModal from '../Common/SwModal/SwModal';


const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
function TopUpWallet() {
    const [collapsed, setCollapsed] = useState(true);

    const [selectedType, setSelectedType] = useState(localStorage.getItem('selectedType') || 'Monthly');
    const [topUp, setTopUp] = useState('');
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    let end_date = moment(moment(startDate, 'YYYY-MM-DD').add(1, 'M')).format(
        'YYYY-MM-DD',
    );
    const [endDate, setEndDate] = useState(end_date);
    const [noOfEmployee, setNoOfEmployee] = useState('');
    const [empPoints, setEmpPoints] = useState('');
    const [empCountPerMonth, setEmpCountPerMonth] = useState('');
    const [selected, setSelected] = useState([]);
    const [topUpAccess, setTopUpAccess] = useState('');
    const [startDateAccess, setStartDateAccess] = useState(moment().format('YYYY-MM-DD'));
    let end_date_access = moment(moment(startDateAccess, 'YYYY-MM-DD').add(1, 'M')).format(
        'YYYY-MM-DD',
    );
    const [endDateAccess, setEndDateAccess] = useState(end_date_access);
    const [noOfEmployeeAccess, setNoOfEmployeeAccess] = useState('');
    const [empPointsAccess, setEmpPointsAccess] = useState('');
    const [workingDaysAccess, setWorkingDaysAccess] = useState('')
    const [noOfWorkingDays, setNoOfWorkingDays] = useState(0);
    const locationWithShortName = allLocationWithShortName();
    let locationShort = JSON.parse(locationWithShortName);
    const [locationNew, setLocationNew] = useState(locationShort);
    const [requestMail, setRequestMail] = useState();
    const [requestMessage, setRequestMessage] = useState();
    const [requestMailAccess, setRequestMailAccess] = useState();
    const [requestMessageAccess, setRequestMessageAccess] = useState();

    const location_name = getLocationNameById(
        locationNew,
        UserObj.loc_rec_id,
    )

    const sendProductEnquiryMail = () => {
        let authToken = JSON.parse(localStorage.getItem('headData'))
        let param = {
            product_name: "Wallet Point",
            company_name: UserObj.company_name,
            email: UserObj.email,
            fname: UserObj.fname,
            lname: UserObj.lname,
            phone: UserObj.phone,
            location_name: location_name,
            location_id: UserObj.loc_rec_id
        }

        axios.post(`${process.env.REACT_APP_API_URL}basic-data/new-product-enquiry`, param, {
            headers: {
                Authorization: authToken?.spintlyToken,
            }
        }).then(res => {
            if (res.status == 200) {
                toast.success(res.data.message, {

                });
            }
        }).catch(err => {
            toast.error('Unable to submit Product enquiry', {

            });

        })
    }

    const handleTypeSelect = (type) => {
        setSelectedType(type);
        if (type == "Monthly") {
            setTopUpAccess("");
            setEmpPointsAccess("");
            setNoOfEmployeeAccess("");
            setWorkingDaysAccess("");
            setTopUp("");
            setEmpCountPerMonth("");
            setEmpPoints("");
            setNoOfEmployee("");
        }
    };

    const handleTopUp = (e) => {
        setTopUp(e.target.value);
    }
    const handleStartDate = (e) => {
        var end_date = moment(
            moment(e.target.value, 'YYYY-MM-DD').add(1, 'M'),
        ).format('YYYY-MM-DD');
        setStartDate(e.target.value);
        setEndDate(end_date);
    }
    const handleEndDate = (e) => {
        setEndDate(e.target.value);
    }
    const handleNoOfEmployee = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setNoOfEmployee(value);
        }
    };


    const handleEmpPoints = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setEmpPoints(value);
        }
    }
    const handleEmpCountPerMonth = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setEmpCountPerMonth(value);
        }
    }
    //Access handle
    const handleTopUpAccess = (e) => {
        setTopUpAccess(e.target.value)
    }

    const handleStartDateAccess = (e) => {
        var end_date = moment(
            moment(e.target.value, 'YYYY-MM-DD').add(1, 'M'),
        ).format('YYYY-MM-DD');
        setStartDateAccess(e.target.value);
        setEndDateAccess(end_date);
    }

    const handleEndDateAccess = (e) => {
        setEndDateAccess(e.target.value)
    }

    const handleNoOfEmployeeAccess = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setNoOfEmployeeAccess(value);
        }
    }

    const handleEmpPointsAccess = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setEmpPointsAccess(value);
        }
    }

    const handleWorkingDayAccess = (e) => {
        const value = e.target.value;
        if (!isNaN(value) && value >= 0) {
            setWorkingDaysAccess(value);
        }
    }

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();

        // Add leading zero if month or day is less than 10
        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }

        return `${year}-${month}-${day}`;
    };


    const handleSubmitRequest = async () => {
        try {
            let authToken = JSON.parse(localStorage.getItem('headData'));

            const params = {
                userId: UserObj?.rec_id,
                type: selectedType === 'Monthly' ? 'monthly' : 'frAccess',
                amount: empPoints,
                startDate,
                endDate,
                noOfEmployees: noOfEmployee,
                pointsPerEmployee: empPoints,
                expectedNewEmployees: empCountPerMonth || "0"
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}wallet/requestWalletPlan`,
                params,
                { headers: { Authorization: authToken?.spintlyToken } }
            );

            setRequestMail(response.data.statusValue);
            setRequestMessage(response.data.message);
            setShowRequestMail(true); // 👈 OPEN MODAL HERE

            setTopUp("");
            setEmpCountPerMonth("");
            setEmpPoints("");
            setNoOfEmployee("");

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };





    const handleAccessSubmitRequest = async () => {
        try {
            let authToken = JSON.parse(localStorage.getItem('headData'));

            const params = {
                userId: UserObj?.rec_id,
                type: selectedType === 'Monthly' ? 'monthly' : 'frAccess',
                amount: empPointsAccess,
                startDate: startDateAccess,
                endDate: endDateAccess,
                weekDays: selected?.map(item => item.value),
                noOfEmployees: noOfEmployeeAccess,
                pointsPerEmployee: empPointsAccess,
                workingDays: workingDaysAccess
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}wallet/requestWalletPlan`,
                params,
                { headers: { Authorization: authToken?.spintlyToken } }
            );

            setRequestMailAccess(response.data.statusValue);
            setRequestMessageAccess(response.data.message);
            setShowRequestMailAccess(true); // 👈 OPEN HERE

            setTopUpAccess("");
            setEmpPointsAccess("");
            setNoOfEmployeeAccess("");
            setWorkingDaysAccess("");

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };



    useEffect(() => {
        localStorage.setItem('selectedType', selectedType);
    }, [selectedType]);

    const options = [
        {
            label: "Monday",
            value: "Monday",
            name: 1
        },
        {
            label: "Tuesday",
            value: "Tuesday",
            name: 2
        },
        {
            label: "Wednesday",
            value: "Wednesday",
            name: 3
        },
        {
            label: "Thursday",
            value: "Thursday",
            name: 4
        },
        {
            label: "Friday",
            value: "Friday",
            name: 5
        },
    ]

    const handleChange = selectedOptions => {
        setSelected(selectedOptions);
    };

    //Calculation for monthly autopopup user
    // const start = new Date(startDate);
    // const end = new Date(endDate);
    // const differenceInMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1;
    let finalPointsresult;

    if (empCountPerMonth) {
        finalPointsresult = (parseInt(noOfEmployee) + parseInt(empCountPerMonth)) * parseInt(empPoints);
    } else {
        finalPointsresult = parseInt(noOfEmployee) * parseInt(empPoints);
    }
    //Calculation for FRAccess
    // const calculateWorkingDays = () => {
    //     const weekdays = selected.map((day) => parseInt(day.name));
    //     const start = new Date(startDateAccess);
    //     const end = new Date(endDateAccess);
    //     let count = 0;

    //     while (start <= end) {
    //         if (weekdays.includes(start.getDay())) {
    //             count++;
    //         }
    //         start.setDate(start.getDate() + 1);
    //     }

    //     setNoOfWorkingDays(count);
    // };

    // useEffect(() => {
    //     if (startDateAccess && endDateAccess && selected.length > 0) {
    //         calculateWorkingDays();
    //     }
    // }, [startDateAccess, endDateAccess, selected]);
    const toggleCollapsed = () => {
        setCollapsed((prevState) => !prevState);
    };

    const calculateFRAccessCalculatin = (parseInt(noOfEmployeeAccess) * parseInt(empPointsAccess) * parseInt(workingDaysAccess));



    const [showRequestMail, setShowRequestMail] = useState(false);
    const [showRequestMailAccess, setShowRequestMailAccess] = useState(false);


    return (
        <>
            <Layout>
                <Sidebar collapsed={collapsed} />
                <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

                <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>

                    <div className="PageContent">
                        <div className='Topup_Page'>
                            <div className='SwHeading'>
                                <h2>Automated plans for you</h2>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 TopupSelectorContainer'>
                                    <div className='SwSubHeading Hv2'>
                                        <h4>Select from the two options</h4>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className={`TopupType MonthlyTopupSelector ${selectedType === 'Monthly' ? 'SelectedTopup' : ''}`} onClick={() => handleTypeSelect('Monthly')}>
                                        <div>
                                            <div className='TopupType_Title'>
                                                <h4>A- Monthly auto distribution of Points</h4>
                                                {/* <p>Explainer text here</p> */}
                                            </div>
                                        </div>
                                        <div className='selectionIcon'>
                                            <div className='DeselectIcon'>
                                                {/* <img src={DeselectTupupicon} /> */}
                                                <i className="bi bi-circle-fill"></i>
                                            </div>
                                            <div className='SelectIcon'>
                                                {/* <img src={SelectTupupicon} /> */}
                                                <i className="bi bi-check-circle-fill"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div className={`TopupType AccessBasedTopupSelector ${selectedType === 'AccessBased' ? 'SelectedTopup' : ''}`} onClick={() => handleTypeSelect('AccessBased')}>
                                        <div>
                                            <div className='TopupType_Title'>
                                                <h4>B- Access-based distribution of Points</h4>
                                                {/* <p>Explainer text here</p> */}
                                            </div>
                                        </div>
                                        <div className='selectionIcon'>
                                            <div className='DeselectIcon'>
                                                {/* <img src={DeselectTupupicon} /> */}
                                                <i className="bi bi-circle-fill"></i>
                                            </div>
                                            <div className='SelectIcon'>
                                                {/* <img src={SelectTupupicon} /> */}
                                                <i className="bi bi-check-circle-fill"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            {/* Monthly Topup */}
                            {selectedType === 'Monthly' && (
                                <section className='TopupMainSection MonthlyTopup'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='TopupFormContainer'>
                                                <div className='MonthlyTopupIcon'>
                                                    <img src={MonthlyTopupIcon} />
                                                </div>
                                                <h3>Monthly Distribution</h3>
                                                <p>All your registered members will automatically receive the Wallet Points on the first of every month</p>
                                                <div className='TopupForm'>
                                                    <form>
                                                        <div className='row '>
                                                            <div className='col-md-8'>
                                                                <div className='row'>
                                                                    <div className='col-md-6'>
                                                                        <div className='SwFormGroup'>
                                                                            <label className='SwFormLabel'>Start Date<span className="Required">*</span></label>
                                                                            <AntDDatePicker
                                                                                value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                                                                                onChange={(date) => {
                                                                                    if (!date) return;
                                                                                    const formatted = date.format("YYYY-MM-DD");
                                                                                    handleStartDate({ target: { value: formatted } });
                                                                                }}
                                                                                format="DD/MM/YYYY"
                                                                                disabledDate={(current) =>
                                                                                    current && current < dayjs(getCurrentDate(), "YYYY-MM-DD")
                                                                                }
                                                                                allowClear={false}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                    <div className='col-md-6'>
                                                                        <div className='SwFormGroup'>
                                                                            <label className='SwFormLabel'>End Date<span className="Required">*</span></label>
                                                                            <AntDDatePicker
                                                                                value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                                                                                onChange={(date) => {
                                                                                    if (!date) return;
                                                                                    handleEndDate({
                                                                                        target: { value: date.format("YYYY-MM-DD") },
                                                                                    });
                                                                                }}
                                                                                format="DD/MM/YYYY"
                                                                                disabledDate={(current) =>
                                                                                    current &&
                                                                                    current <
                                                                                    dayjs(startDate, "YYYY-MM-DD").add(1, "month")
                                                                                }
                                                                                allowClear={false}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row mt-3'>
                                                            <div className='col'>
                                                                <SwButton
                                                                    variant="dark"
                                                                    disabled={!startDate || !endDate || !noOfEmployee || !empPoints}
                                                                    onClick={handleSubmitRequest}
                                                                >
                                                                    Submit Request
                                                                </SwButton>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='col-md-6'>
                                            <div className='PointCalcContainer'>
                                                <div className='PointCalcHeader'>
                                                    Your Point Calculator
                                                </div>
                                                <div className='PointCalBody'>
                                                    <div className='PointCalForm'>
                                                        <form>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>No. of Employees (current)<span className="Required">*</span></label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={noOfEmployee}
                                                                            onChange={handleNoOfEmployee}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>Points per Employees<span className="Required">*</span></label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={empPoints}
                                                                            onChange={handleEmpPoints}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>Expected New employees in Month</label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={empCountPerMonth}
                                                                            onChange={handleEmpCountPerMonth}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                                <div className='col'>
                                                                    <div className='PointsRequired'>
                                                                        <label className="SwFormLabel">Approx points required per month:</label>
                                                                        <div className='PointsRequiredValue'>
                                                                            <img src={wallelBalicon} />
                                                                            <span>{isNaN(finalPointsresult) ? "0" : finalPointsresult}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </section>
                            )}

                            {/* Access Based Topup */}
                            {selectedType === 'AccessBased' && (
                                <section className='TopupMainSection AccessBasedTopup'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='TopupFormContainer'>
                                                <div className='MonthlyTopupIcon'>
                                                    <img src={AccessBasedIcon} />
                                                </div>
                                                <h3>Access based Distribution</h3>
                                                <p>All your registered members will automatically receive the Wallet Points after getting access</p>
                                                <div className='TopupForm'>
                                                    <form>
                                                        <div className='row'>
                                                            
                                                            <div className='col-md-8'>
                                                                <div className='row'>
                                                                    <div className='col-md-6'>
                                                                        <div className='SwFormGroup'>
                                                                            <label className='SwFormLabel'>Start Date<span className="Required">*</span></label>
                                                                            <AntDDatePicker
                                                                                value={startDateAccess ? dayjs(startDateAccess, "YYYY-MM-DD") : null}
                                                                                onChange={(date) => {
                                                                                    if (!date) return;
                                                                                    handleStartDateAccess({
                                                                                        target: { value: date.format("YYYY-MM-DD") },
                                                                                    });
                                                                                }}
                                                                                format="DD/MM/YYYY"
                                                                                disabledDate={(current) =>
                                                                                    current && current < dayjs(getCurrentDate(), "YYYY-MM-DD")
                                                                                }
                                                                                allowClear={false}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-6'>
                                                                        <div className='SwFormGroup'>
                                                                            <label className='SwFormLabel'>End Date<span className="Required">*</span></label>
                                                                            <AntDDatePicker
                                                                                value={endDateAccess ? dayjs(endDateAccess, "YYYY-MM-DD") : null}
                                                                                onChange={(date) => {
                                                                                    if (!date) return;
                                                                                    handleEndDateAccess({
                                                                                        target: { value: date.format("YYYY-MM-DD") },
                                                                                    });
                                                                                }}
                                                                                format="DD/MM/YYYY"
                                                                                disabledDate={(current) =>
                                                                                    current &&
                                                                                    current <
                                                                                    dayjs(startDateAccess, "YYYY-MM-DD").add(1, "month")
                                                                                }
                                                                                allowClear={false}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row '>
                                                            
                                                            <div className='col-md-5'>
                                                                <div className="SwFormGroup">
                                                                    <label className="SwFormLabel">Select week days</label>
                                                                    <SwMultiSelect
                                                                        id="inputState"
                                                                        options={options}
                                                                        value={selected}
                                                                        onChange={handleChange}
                                                                        labelledBy="Select"
                                                                        placeholder="Select"
                                                                        selectAllLabel="Select All"
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row mt-3'>
                                                            <div className='col'>
                                                                <SwButton
                                                                    variant="dark"
                                                                    disabled={!startDateAccess || !endDateAccess || !noOfEmployeeAccess || !empPointsAccess || !workingDaysAccess}
                                                                    onClick={handleAccessSubmitRequest}
                                                                >
                                                                    Submit Request
                                                                </SwButton>

                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='PointCalcContainer'>
                                                <div className='PointCalcHeader'>
                                                    Your Point Calculator
                                                </div>
                                                <div className='PointCalBody'>
                                                    <div className='PointCalForm'>
                                                        <form>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>No. of Employees (current)<span className="Required">*</span></label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={noOfEmployeeAccess}
                                                                            onChange={handleNoOfEmployeeAccess}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-md-9'>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>Points per Top-up<span className="Required">*</span></label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={empPointsAccess}
                                                                            onChange={handleEmpPointsAccess}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-md-9 '>
                                                                    <div className='SwFormGroup'>
                                                                        <label className='SwFormLabel'>Average days worked in the office per employee per month<span className="Required">*</span></label>
                                                                        <SwInput
                                                                            type='text'
                                                                            placeholder="Enter the value"
                                                                            value={workingDaysAccess}
                                                                            onChange={handleWorkingDayAccess}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                                <div className='col'>
                                                                    <div className='PointsRequired'>
                                                                        <label className='SwFormLabel'>Points required:</label>
                                                                        <div className='PointsRequiredValue'>
                                                                            <img src={wallelBalicon} />
                                                                            <span><span>{isNaN(calculateFRAccessCalculatin) ? "0" : calculateFRAccessCalculatin}</span></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </section>
                            )}

                        </div>


                        {/* Point Distribution Cart */}
                        <div className='TopupContactStrip SwTextWhite'>

                            <div className="SwSubHeading Hv2">
                                <h3 className='mb-0'>
                                    <img src={HelpImg} width={40} className='me-2' />
                                    <span>If you have any query reach out to our Account Manager</span>
                                </h3>
                            </div>

                            <SwButton 
                                onClick={sendProductEnquiryMail}
                                variant='light'
                                icon={<i className="bi bi-arrow-right"></i>}
                                iconPosition='end'
                            >
                                Contact Us
                            </SwButton>

                        </div>

                    </div>



                    {/* Request Mail Alert modal Success */}
                    <SwModal
                        show={showRequestMail}
                        onClose={() => setShowRequestMail(false)}
                        className="sw-small-modal"
                        footer={
                            <div className="d-flex justify-content-center">
                            <SwButton
                                variant="dark-outline"
                                size="sm"
                                onClick={() => setShowRequestMail(false)}
                            >
                                Close
                            </SwButton>
                            </div>
                        }
                        >
                        {requestMail === 200 ? (
                            <div className="PoinAlertPopup_Cntent text-center">
                            <img src={SuccessIcon} className="PoinAlertPopup_Icon" />
                            <h3>Request submitted successfully</h3>
                            <p>Your account manager will get in touch with you</p>
                            </div>
                        ) : (
                            <div className="PoinAlertPopup_Cntent text-center">
                            <img src={insufficientBalIcon} className="PoinAlertPopup_Icon" />
                            <h3>{requestMessage}</h3>
                            <p>Your account manager will get in touch with you</p>
                            </div>
                        )}
                    </SwModal>


                    {/* Request Mail Access modal Success */}
                    <SwModal
                        show={showRequestMailAccess}
                        onClose={() => setShowRequestMailAccess(false)}
                        className="sw-small-modal"
                        footer={
                            <div className="d-flex justify-content-center">
                            <SwButton
                                variant="dark-outline"
                                size="sm"
                                onClick={() => setShowRequestMailAccess(false)}
                            >
                                Close
                            </SwButton>
                            </div>
                        }
                        >
                        {requestMailAccess === 200 ? (
                            <div className="PoinAlertPopup_Cntent text-center">
                            <img src={SuccessIcon} className="PoinAlertPopup_Icon" />
                            <h3>Request submitted successfully</h3>
                            <p>Your account manager will get in touch with you</p>
                            </div>
                        ) : (
                            <div className="PoinAlertPopup_Cntent text-center">
                            <img src={insufficientBalIcon} className="PoinAlertPopup_Icon" />
                            <h3>{requestMessageAccess}</h3>
                            <p>Your account manager will get in touch with you</p>
                            </div>
                        )}
                    </SwModal>
                </Layout>
            </Layout>

        </>
    )
}
export default TopUpWallet